import { render } from "./CometChatReceiverImageMessageBubble.vue?vue&type=template&id=4fd9b578&scoped=true"
import script from "./CometChatReceiverImageMessageBubble.vue?vue&type=script&lang=js"
export * from "./CometChatReceiverImageMessageBubble.vue?vue&type=script&lang=js"

import "./CometChatReceiverImageMessageBubble.vue?vue&type=style&index=0&id=4fd9b578&scoped=true&lang=css"
import "./CometChatReceiverImageMessageBubble.vue?vue&type=style&index=1&id=4fd9b578&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd9b578"]])

export default __exports__